/** Frontend formatting helpers for the chats viewer (pure, no locale APIs). */

import { CHAT_CHANNELS, MESSAGE_CONSTANTS } from '@federa/const/messaging';
import { humanizeSnakeCase } from '@federa/const/string-case';
import { capitalizeFirst } from '@federa/utils/strings/transform';
import { viewerVar } from './chats-viewer-tokens.ts';

/** Trim an ISO8601 / 'YYYY-MM-DD HH:MM:SS' timestamp to a compact 'YYYY-MM-DD HH:MM'. */
export function formatTime(value: string | null): string {
	if (!value) return '';
	const s = value.replace('T', ' ');
	return s.length >= 16 ? s.slice(0, 16) : s;
}

/** Channel -> dot color (sms = amber, web/chat = blue, else faint). */
export function channelColor(channel: string | null): string {
	if (channel === CHAT_CHANNELS.SMS) return viewerVar('--sms');
	if (channel === MESSAGE_CONSTANTS.SERVICE_WEB || channel === CHAT_CHANNELS.CHAT) return viewerVar('--web');
	return viewerVar('--text-faint');
}

/** A human title for a conversation: its friendly name, else a shortened id. */
export function conversationTitle(friendlyName: string | null, id: string): string {
	if (friendlyName && friendlyName.trim()) return friendlyName.trim();
	return id.length > 18 ? `${id.slice(0, 18)}...` : id;
}

/** Title-case a snake/lower label (role, etc.): the two utils transforms composed, not re-inlined. */
export function prettyLabel(value: string | null): string {
	return capitalizeFirst(humanizeSnakeCase(value ?? ''));
}
